export let CreateFromTimezone = {};

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/en'

dayjs.extend(utc);

CreateFromTimezone.install = function () {
    if (dayjs) {
        dayjs.createFromTimezone = (date, timezone) => {
            if (!date) {
                return dayjs(new Date().toLocaleString("en-US", {timeZone: timezone}));
            }

            if (typeof date !== 'string') {
                date = date.toLocaleString();
            }

            if (!new Date(date).getTime() && date.split('+')[1]) {
                date = date.replace(' ', 'T') + ':00';
            } else if (!date.split('+')[1] && !(date.indexOf('Z') + 1)) {
                date = date.replace(' ', 'T') + '+00:00';
            }

            return dayjs(new Date(date).toLocaleString("en-US", {timeZone: timezone}));
        };
        dayjs.toStringWithoutTimezone = (date) => {
            if (!date) {
                return dayjs().locale('en').format('YYYY-MM-DD HH:mm');
            }

            return dayjs(date).locale('en').format('YYYY-MM-DD HH:mm');
        };
    }
};
